class inview {
  constructor(myQuery, myOptions) {
    const defaults = {
      root: null,
      margin: '0% 0%',
      threshold: 0,
      viewIn: function () {
        this.target.classList.add('inviewed');
      },
      viewOut: function () {
        this.target.classList.remove('inviewed');
      },
      once: true,
    };
    let opts = { ...defaults, ...myOptions };
    this.query = myQuery;
    this.settings = opts;
    const nodelist = document.querySelectorAll(this.query);
    const node = Array.from(nodelist).reverse();
    const options = {
      root: this.settings.root,
      rootMargin: this.settings.margin,
      threshold: this.settings.threshold,
    };
    const onceFlag = this.settings.once;
    const callback = (entries, observer) => {
      entries.forEach((entry) => {
        this.settings.target = entry.target;
        if (entry.isIntersecting) {
          this.settings.viewIn();
          if (onceFlag) {
            observer.unobserve(entry.target);
          }
        } else {
          this.settings.viewOut();
        }
      });
    };
    const observer = new IntersectionObserver(callback, options);
    node.forEach((obj) => observer.observe(obj));
  }
}
(function(){
  const js_inview_addclass = new inview('.js_inview', {margin: '-20% 0%'});
  const ekiben = new inview('.photolist__item', {margin: '-25% 0% -75%',once: false});
  
})();

